module.exports = __webpack_public_path__ + "static/media/car-placeholder.7da7ce58.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/car-placeholder.svg
 ** module id = 253
 ** module chunks = 0
 **/